<template>
  <div class="scroll_flex_container">
    <navbar title="LINE訂單"></navbar>

    <div class="scroll_flex_container w-full">
      <ul v-infinite-scroll="load" :infinite-scroll-distance="100" :infinite-scroll-immediate="false"
        class="infinite-list"
        style="overflow-y: auto; overflow-x: hidden; width: 100%; padding: 0;-ms-overflow-style: none;scrollbar-width: none;">
        <div class="column_center_start" v-for="(group, index) in orderHistoryList" :key="index" style="width: 100%;">
          <div class="row_center_start w-full py-3.5 px-[3%]">
            <text class="order_date">{{ group.date }}</text>
          </div>
          <orderHistory v-for="(item, index) in group.list" :key="index" :item="item" :cancelable="true" :is-online-context="true" @cancelOrder="showDialog"></orderHistory>
        </div>
        <div v-if="!hasMore" class="row_center_center w-full px-[5%]"><el-divider
            style="border-top: 1px solid #AAAAAA; color: #AAAAAA;">沒有更多訂單</el-divider></div>
      </ul>
    </div>
    <div>
      <confirmCancel ref="confirmCancel" @confirm="cancelOrder"></confirmCancel>
    </div>
  </div>
</template>
<script>
import navbar from "@/components/general/navbar.vue"
import commonUtils from "@/utils/common.utils";
import auth from "@/utils/auth.utils"
import { mapState, mapGetters } from 'vuex'
import orderHistory from '@/components/orderHistory/orderHistory.vue'
import confirmCancel from '@/components/orderHistory/confirmCancel.vue'
export default {
  components: {
    navbar,
    orderHistory,
    confirmCancel
  },
  computed: {
    ...mapGetters('order', {
      orderHistoryList: 'sortedOnlineOrderHistory',
      hasMore: 'hasMoreOnlineOrderHistory'
    }),
    ...mapState('basic', {
      currentStore: 'currentStore',
    }),
    ...mapGetters('userData', {
      isLogin: 'isLogin'
    })
  },
  async mounted() {
    if (!this.isLogin) {
      commonUtils.createToast("warning", "登入狀態已過期，請重新登入");
      await commonUtils.delay(1500)
      auth.logout()
      this.$router.push({
        path: `/${this.currentStore}`
      })
      return
    }
    this.$store.commit('order/setOnlineOrderHistoryPage', 0)
    this.$store.commit('order/setOnlineOrderHistory', [])
    await this.load()
  },
  methods: {
    async load() {
      if (!this.hasMore) return
      try {
        commonUtils.createLoading("資料讀取中", "請稍後");
        await this.$store.dispatch('order/fetchOnlineOrderHistory')
        await commonUtils.delay(500)
        commonUtils.closeLoading();
      } catch (e) {
        console.log('fetch online order history error', e)
        await commonUtils.delay(500)
        commonUtils.closeLoading();
        commonUtils.createToast('warning', e)
      }
    },
    showDialog(orderItem) {
      this.$refs.confirmCancel.showDialog(orderItem)
    },
    async cancelOrder(orderItem) {
      try {
        console.log('cancel order', orderItem.orderNumber)
        if (orderItem.isUnprocessed) {
          commonUtils.createLoading("取消訂單中", "請稍後");
          await this.$store.dispatch('order/cancelOnlineOrder', orderItem.orderNumber)
          this.$store.commit('order/setOnlineOrderHistoryPage', 0)
          this.$store.commit('order/setOnlineOrderHistory', [])
          await this.$store.dispatch('order/fetchOnlineOrderHistory')
          await commonUtils.delay(500)
          commonUtils.closeLoading();
          commonUtils.createToast('success', '取消訂單成功')
        } else {
          commonUtils.createToast('warning', '訂單已經處理中，無法取消')
        }
      } catch (e) {
        console.log('cancel online order error', e)
        commonUtils.createToast('warning', e)
      }
    }
  },
};
</script>
<style lang="scss">

</style>
